const ActionEntityOperationCreate = () => {
  return (
    <div>
      <h1>ActionEntityOperationCreate</h1>
    </div>
  )
}

export default ActionEntityOperationCreate
